module.exports = __webpack_public_path__ + "assets/img/3.de5e3861.png";